import live from '@images/homepage/home_icon_live.png'

import { createStyles } from '@zn-material-ui'
export default () =>
  createStyles({
    card: {
      width: '100%',
      minWidth: 310,
      fontSize: '14px',
      color: '#666',
      boxShadow: 'none',
      marginBottom: '10px',
    },
    title: {
      fontSize: 16,
      color: '#000',
      borderBottom: '1px solid #E5E5E5',
      height: 50,
      boxSizing: 'border-box',
      lineHeight: '50px',
      paddingLeft: '26px',
      letterSpacing: 'initial !important',
    },
    content: {
      padding: 0,
    },
    iconBar: {
      padding: '24px 28px',
      display: 'flex',
      flexDirection: 'column',
      '& a': {
        display: 'inline-block',
        margin: '0',
      },
      '& a:hover': {
        textDecoration: 'none',
      },
    },
    entryWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 10,
    },
    iconItem: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      alignItems: 'center',
      fontSize: '14px',
      color: '#666666',
      margin: '8px 0 0',
      letterSpacing: 'initial !important',
      textAlign: 'center',
      width: '85px',
    },
    icon: {
      display: 'inline-block',
      width: 50,
      height: 50,
      marginBottom: '2px',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    },
    count: {
      position: 'absolute',
      width: '12px',
      height: '12px',
      background: '#FA534A',
      borderRadius: '50%',
      display: 'inline-block',
      right: '15px',
      top: '-1px',
      '&:first-child': {
        color: 'red',
      },
    },
    cardTitle: {
      width: '100%',
      wordWrap: 'break-word',
      wordBreak: 'normal',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
    },
    live: {
      backgroundImage: `url(${live})`,
    },
  })
